export default {
  searchQuery: '',
  searchResults: []
}
